import '../styles.scss'
import React from 'react'

import { Selector } from 'components/SmartChatView/Fields'

const ProcessSentimentViewUI = ({ renderType, label, placeholder, processSentimentOptions, value, onChangeInner, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <Selector
        isRequired
        label={label.sentiment}
        placeholder={placeholder.sentiment}
        options={processSentimentOptions}
        value={value.sentiment}
        onChange={value => onChangeInner({ fieldType: 'sentiment', fieldData: value })}
        error={error?.sentiment}
      />
    )}
    {renderType === 'preview' && (
      <div className='action-view__process-sentiment-preview'>
        <Selector
          placeholder={placeholder.sentiment}
          options={processSentimentOptions}
          value={value.sentiment}
          onChange={value => onChangeInner({ fieldType: 'sentiment', fieldData: value })}
          error={previewIntegrity.sentiment}
        />
      </div>
    )}
  </div>
)

export default ProcessSentimentViewUI
